export interface PresetPortfolioItem {
  figi: string;
  symbol: string;
  name: string;
  market_value?: number;
  weight?: number;
  logo?: string | null;
  logo_color?: string | null;
}

export interface PresetPortfolio {
  id: string;
  name: string;
  items: PresetPortfolioItem[];
}

// Static portfolios with hardcoded FIGIs and logo_colors
export const PRESET_PORTFOLIOS: PresetPortfolio[] = [
  {
    id: "mag7",
    name: "Mag 7",
    items: [
      {
        figi: "BBG000B9XRY4",
        symbol: "AAPL",
        name: "Apple Inc.",
        logo_color:
          "https://pebble.finance/static-be/logos/color/0000320193_1678392326.882197.png",
      },
      {
        figi: "BBG000BPH459",
        symbol: "MSFT",
        name: "Microsoft Corp.",
        logo_color:
          "https://pebble.finance/static-be/logos/color/0000789019_1678391806.715968.png",
      },
      {
        figi: "BBG009S39JX6",
        symbol: "GOOGL",
        name: "Alphabet Inc.",
        logo_color:
          "https://pebble.finance/static-be/logos/color/0001652044_1678391543.083504.png",
      },
      {
        figi: "BBG000BVPV84",
        symbol: "AMZN",
        name: "Amazon.com Inc.",
        logo_color:
          "https://pebble.finance/static-be/logos/color/0001018724_1678391909.576425.png",
      },
      {
        figi: "BBG000BBJQV0",
        symbol: "NVDA",
        name: "NVIDIA Corp.",
        logo_color:
          "https://pebble.finance/static-be/logos/color/0001045810_1678391521.189376.png",
      },
      {
        figi: "BBG000MM2P62",
        symbol: "META",
        name: "Meta Platforms",
        logo_color:
          "https://pebble.finance/static-be/logos/color/0001326801_1678391713.143432.png",
      },
      {
        figi: "BBG000N9MNX3",
        symbol: "TSLA",
        name: "Tesla Inc.",
        logo_color:
          "https://pebble.finance/static-be/logos/color/0001318605_1678392515.450929.png",
      },
    ],
  },
  {
    id: "cloud",
    name: "Cloud",
    items: [
      {
        figi: "BBG008HBD923",
        symbol: "SHOP",
        name: "Shopify Inc.",
        logo_color:
          "https://pebble.finance/static-be/logos/color/0001594805_1678392437.279021.png",
      },
      {
        figi: "BBG007DHGNJ4",
        symbol: "SNOW",
        name: "Snowflake Inc.",
        logo_color:
          "https://pebble.finance/static-be/logos/color/0001640147_1678391845.656668.png",
      },
      {
        figi: "BBG003338H34",
        symbol: "ZS",
        name: "Zscaler Inc.",
        logo_color:
          "https://pebble.finance/static-be/logos/color/0001713683_1678391171.029247.png",
      },
      {
        figi: "BBG0026ZJ304",
        symbol: "PCOR",
        name: "Procore Technologies Inc.",
        logo_color:
          "https://pebble.finance/static-be/logos/color/0001611052_1678392219.487681.png",
      },
      {
        figi: "BBG0029ZX840",
        symbol: "TWLO",
        name: "Twilio Inc.",
        logo_color:
          "https://pebble.finance/static-be/logos/color/0001447669_1678391102.136003.png",
      },
      {
        figi: "BBG007BVZ8H9",
        symbol: "WK",
        name: "Workiva Inc.",
        logo_color:
          "https://pebble.finance/static-be/logos/color/0001445305_1678391417.972288.png",
      },
      {
        figi: "BBG0042V6JM8",
        symbol: "ZM",
        name: "Zoom Video Communications Inc.",
        logo_color:
          "https://pebble.finance/static-be/logos/color/0001585521_1678392125.534024.png",
      },
      {
        figi: "BBG000PMSK08",
        symbol: "BOX",
        name: "Box Inc.",
        logo_color:
          "https://pebble.finance/static-be/logos/color/0001372612_1678391656.419344.png",
      },
      {
        figi: "BBG0018SLDN0",
        symbol: "DBX",
        name: "Dropbox Inc.",
        logo_color:
          "https://pebble.finance/static-be/logos/color/0001467623_1678391891.972963.png",
      },
    ],
  },
  {
    id: "big_oil",
    name: "Big Oil",
    items: [
      {
        figi: "BBG000GZQ728",
        symbol: "XOM",
        name: "Exxon Mobil Corp.",
        logo_color:
          "https://pebble.finance/static-be/logos/color/0000034088_1678391481.308719.png",
      },
      {
        figi: "BBG000K4ND22",
        symbol: "CVX",
        name: "Chevron Corp.",
        logo_color:
          "https://pebble.finance/static-be/logos/color/0000093410_1678391416.816731.png",
      },
      {
        figi: "BBG000BHBGN6",
        symbol: "COP",
        name: "ConocoPhillips",
        logo_color:
          "https://pebble.finance/static-be/logos/color/0001163165_1678391486.353365.png",
      },
      {
        figi: "BBG000BZ7S24",
        symbol: "EOG",
        name: "EOG Resources Inc.",
        logo_color:
          "https://pebble.finance/static-be/logos/color/0000821189_1678392445.068973.png",
      },
      {
        figi: "BBG000BRHPB9",
        symbol: "SLB",
        name: "SLB NV",
        logo_color:
          "https://pebble.finance/static-be/logos/color/0000087347_1678391236.753159.png",
      },
      {
        figi: "BBG000BBNX26",
        symbol: "MPC",
        name: "Marathon Petroleum Corp.",
        logo_color:
          "https://pebble.finance/static-be/logos/color/0001510295_1678392078.777172.png",
      },
      {
        figi: "BBG0025P22X1",
        symbol: "PSX",
        name: "Phillips 66",
        logo_color:
          "https://pebble.finance/static-be/logos/color/0001534701_1678391744.900065.png",
      },
      {
        figi: "BBG000BMXVR4",
        symbol: "KMI",
        name: "Kinder Morgan Inc.",
        logo_color:
          "https://pebble.finance/static-be/logos/color/0001506307_1678391620.558514.png",
      },
    ],
  },
  {
    id: "bogleheads",
    name: "Bogleheads",
    items: [
      {
        figi: "BBG0015VYNT4",
        symbol: "VOO",
        name: "Vanguard S&P 500",
        weight: 50,
        logo_color:
          "https://pebble.finance/static-be/logos/color/0000036405_1723186861.952615.png",
      },
      {
        figi: "BBG000HR9779",
        symbol: "VTI",
        name: "Vanguard Total Stock",
        weight: 30,
        logo_color:
          "https://pebble.finance/static-be/logos/color/0000036405_1723186861.952615.png",
      },
      {
        figi: "BBG001F8JPC4",
        symbol: "VXUS",
        name: "Vanguard Total Intl",
        weight: 20,
        logo_color:
          "https://pebble.finance/static-be/logos/color/0000736054_1723186847.149632.png",
      },
    ],
  },
  {
    id: "utilities",
    name: "Utilities",
    items: [
      {
        figi: "BBG000BJSBJ0",
        symbol: "NEE",
        name: "NextEra Energy Inc.",
        logo_color:
          "https://pebble.finance/static-be/logos/color/0000753308_1678391393.841925.png",
      },
      {
        figi: "BBG00B3KRLT0",
        symbol: "CEG",
        name: "Constellation Energy Corp.",
        logo_color:
          "https://pebble.finance/static-be/logos/color/0001868275_1678392066.811106.png",
      },
      {
        figi: "BBG000BS7KS3",
        symbol: "SO",
        name: "Southern Co.",
        logo_color:
          "https://pebble.finance/static-be/logos/color/0000092122_1678392142.051674.png",
      },
      {
        figi: "BBG000BLK489",
        symbol: "DUK",
        name: "Duke Energy Corp.",
        logo_color:
          "https://pebble.finance/static-be/logos/color/0001326160_1678392537.552874.png",
      },
      {
        figi: "BBG000BV34Y2",
        symbol: "VST",
        name: "Vistra Corp.",
        logo_color:
          "https://pebble.finance/static-be/logos/color/0001692819_1678391766.537198.png",
      },
      {
        figi: "BBG000BB9KF2",
        symbol: "AEP",
        name: "American Electric Power Co.",
        logo_color:
          "https://pebble.finance/static-be/logos/color/0000004904_1678391922.132578.png",
      },
      {
        figi: "BBG000BS26M7",
        symbol: "SRE",
        name: "Sempra Energy",
        logo_color:
          "https://pebble.finance/static-be/logos/color/0001032208_1678391886.05459.png",
      },
      {
        figi: "BBG000BR8GG6",
        symbol: "XEL",
        name: "Xcel Energy Inc.",
        logo_color:
          "https://pebble.finance/static-be/logos/color/0000072903_1678391224.990302.png",
      },
      {
        figi: "BBG000BN7G37",
        symbol: "EXC",
        name: "Exelon Corp.",
        logo_color:
          "https://pebble.finance/static-be/logos/color/0001109357_1678391985.834652.png",
      },
    ],
  },
];
